import { render, staticRenderFns } from "./ClientesRFV.vue?vue&type=template&id=42ae65cb&scoped=true&"
import script from "./ClientesRFV.vue?vue&type=script&lang=js&"
export * from "./ClientesRFV.vue?vue&type=script&lang=js&"
import style0 from "./ClientesRFV.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ClientesRFV.vue?vue&type=style&index=1&id=42ae65cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae65cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VChip,VCol,VContainer,VIcon,VRow,VTooltip})
